module.exports = __webpack_public_path__ + "img/it.78dad7d7.svg";